import { useEffect } from 'react';
import type { JsonLdNode } from '../seo/jsonLd';

const SCRIPT_ID = 'chisme-json-ld';

export function useJsonLd(data: JsonLdNode | null | undefined) {
  useEffect(() => {
    document.getElementById(SCRIPT_ID)?.remove();
    if (!data) return undefined;

    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(data);
    document.head.appendChild(script);

    return () => {
      document.getElementById(SCRIPT_ID)?.remove();
    };
  }, [data]);
}
